import { useMemo } from 'react';
import { getValidDate } from '@gp/utils/common';

interface Props {
  sourceData: orgHeadcountsDataTypes;
  type: HeadcountsDataType;
}

const useTableList = (props: Props) => {

  const { sourceData, type } = props;

  const resultList = useMemo(() => {
    const targetMetrics = sourceData?.metrics || [], targetData = sourceData?.dataList || [];
    if (!Array.isArray(targetData) || !targetData?.length || !['1', '2']?.includes(type)) return;
    const newRecords = [], newColList = [];
    for (let i = 0; i < targetMetrics?.length; i ++) {
      const t: string = targetMetrics?.[i];
      const row: {[key: string]: string} = {
        uniqueId: String(i),
        metric: t,
      };
      for (let j = 0; j < targetData?.length; j ++) {
        const k: {[key: string]: string} = targetData?.[j];
        const date = getValidDate(k?.date, 'YYYY');
        i === 0 && newColList.push(date || '');
        row[date] = k?.[t];
      }
      newRecords.push(row);
    }

    return {
      records: newRecords,
      colList: newColList,
    };
  }, [sourceData, type]);

  return {
    records: resultList?.records || [],
    colList: resultList?.colList || [],
  };
}

useTableList.defaultProps = {
  sourceData: null,
  type: '1',
}

export default useTableList;
